/**
 * Favicon utility functions
 */

/**
 * Creates a square favicon from a given URL
 * @param {string} url - The favicon URL
 * @param {number} size - The desired size (default: 32)
 * @returns {Promise<string>} - Promise that resolves to the processed favicon URL
 */
export const ensureSquareFavicon = (url, size = 32) =>
  new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = size
        canvas.height = size
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, size, size)
        const scale = Math.min(size / img.width, size / img.height)
        const w = img.width * scale
        const h = img.height * scale
        const x = (size - w) / 2
        const y = (size - h) / 2
        ctx.drawImage(img, x, y, w, h)
        resolve(canvas.toDataURL('image/png'))
      } catch (e) {
        resolve(url)
      }
    }
    img.onerror = () => resolve(url)
    img.src = url
  })
